import type * as SchemaTypes from '../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateAssessmentRunsMutationVariables = SchemaTypes.Exact<{
  companyId: SchemaTypes.Scalars['ObjectID']['input'];
  input: SchemaTypes.CreateAssessmentRunsInput;
}>;


export type CreateAssessmentRunsMutation = (
  { __typename: 'Mutation' }
  & { createAssessmentRuns: (
    { __typename: 'CreateAssessmentRunsSuccessfulResponse' }
    & { result: Array<(
      { __typename: 'AssessmentRun' }
      & Pick<SchemaTypes.AssessmentRun, 'id' | 'name'>
    )> }
  ) | (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) }
);


export const CreateAssessmentRunsDocument = /*#__PURE__*/ gql`
    mutation CreateAssessmentRuns($companyId: ObjectID!, $input: CreateAssessmentRunsInput!) {
  createAssessmentRuns(companyId: $companyId, input: $input) {
    __typename
    ... on CreateAssessmentRunsSuccessfulResponse {
      result {
        id
        name
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    `;
export type CreateAssessmentRunsMutationFn = Apollo.MutationFunction<CreateAssessmentRunsMutation, CreateAssessmentRunsMutationVariables>;

/**
 * __useCreateAssessmentRunsMutation__
 *
 * To run a mutation, you first call `useCreateAssessmentRunsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssessmentRunsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssessmentRunsMutation, { data, loading, error }] = useCreateAssessmentRunsMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAssessmentRunsMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssessmentRunsMutation, CreateAssessmentRunsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssessmentRunsMutation, CreateAssessmentRunsMutationVariables>(CreateAssessmentRunsDocument, options);
      }
export type CreateAssessmentRunsMutationHookResult = ReturnType<typeof useCreateAssessmentRunsMutation>;
export type CreateAssessmentRunsMutationResult = Apollo.MutationResult<CreateAssessmentRunsMutation>;
export type CreateAssessmentRunsMutationOptions = Apollo.BaseMutationOptions<CreateAssessmentRunsMutation, CreateAssessmentRunsMutationVariables>;